import { z } from 'zod';

import { HowYouFindQreamValue } from '@/constants/how-you-find';
import { isValidUrl } from '@/helpers/is-valid-url';

const requireOtherSpecified = (
	data: { howYouFindQream?: string; howYouFindQreamOther?: string },
	ctx: z.RefinementCtx
) => {
	if (data.howYouFindQream === HowYouFindQreamValue.Other && !data.howYouFindQreamOther?.trim())
		ctx.addIssue({
			code: 'custom',
			message: 'Let us know where you heard about us',
			path: ['howYouFindQreamOther']
		});
};

export const brandbookFormSchema = z
	.object({
		name: z.string().min(2, 'Name is required'),
		email: z.email('Invalid email'),
		jobTitle: z.string().optional(),
		howYouFindQream: z.string().optional(),
		howYouFindQreamOther: z.string().optional(),
		details: z.string().min(1, 'Required to fill')
	})
	.superRefine(requireOtherSpecified);

export const contactFormSchema = z
	.object({
		name: z.string().min(2, 'Name is required'),
		email: z.email('Invalid email'),
		jobTitle: z.string().optional(),
		details: z.string().min(1, 'Required to fill'),
		service: z.array(z.string()).min(1, 'Choose at least one option'),
		budget: z.string().min(1, 'Select a budget'),
		howYouFindQream: z.string().optional(),
		howYouFindQreamOther: z.string().optional()
	})
	.superRefine(requireOtherSpecified);

export type BrandbookFormData = z.infer<typeof brandbookFormSchema>;

export type ContactFormData = z.infer<typeof contactFormSchema>;

export enum BrandbookFormStatus {
	Disabled = 'disabled',
	Active = 'active',
	Send = 'send'
}

export const websiteAuditFormSchema = z.object({
	site: z.string().min(1, 'Site is required').refine(isValidUrl, {
		message: 'Please enter a valid https URL'
	}),
	name: z.string().min(2, 'Name is required'),
	email: z.email('Invalid email'),
	jobTitle: z.string().min(1, 'Position is required')
});

export type WebsiteAuditFormData = z.infer<typeof websiteAuditFormSchema>;
